import { p as c } from "./ImageMarkerLoader-aTenj78C.js";
function o(e) {
  if (!e.enabled) return "This marker is disabled.";
  const r = e.localizer;
  if (!r) return "This marker has no localizer.";
  if (r.kind !== "image") return "This localizer type is not supported.";
  if (e.rotationSource === "legacy_heuristic") return "This marker transform has not been resolved.";
  const i = r.widthM;
  return !r.imageUrl || typeof i != "number" || !Number.isFinite(i) || i <= 0 ? "This marker needs an image and a physical width." : l(e) ? null : "This marker transform is invalid.";
}
function l(e) {
  return Array.isArray(e.t) && e.t.length === 3 && Array.isArray(e.q) && e.q.length === 4 && [...e.t, ...e.q].every(Number.isFinite) && Math.abs(Math.hypot(...e.q) - 1) < 1e-3;
}
function d(e) {
  return e.filter((r) => !o(r));
}
function f(e, r) {
  const i = d(e);
  let a;
  if (r !== void 0) {
    if (a = e.find((u) => u.id === r), !a) return {
      status: "unavailable",
      reason: "The selected marker does not exist."
    };
    const t = o(a);
    if (t) return {
      status: "unavailable",
      reason: t
    };
  } else if (a = i.find((t) => t.isPrimary) ?? (i.length === 1 ? i[0] : void 0), !a) return i.length > 1 ? {
    status: "choice-required",
    reason: "Choose a marker before entering AR."
  } : {
    status: "unavailable",
    reason: "No usable marker is available."
  };
  const n = e.find((t) => t.isPrimary);
  return !n || n.rotationSource === "legacy_heuristic" || !l(n) ? {
    status: "unavailable",
    reason: "The authored content frame is unavailable."
  } : {
    status: "selected",
    session: {
      selected: structuredClone(a),
      authoredPose: {
        t: [...n.t],
        q: [...n.q]
      }
    }
  };
}
function m(e, r) {
  const i = f(e, r);
  if (i.status !== "selected") throw new Error(i.reason);
  return i.session;
}
var s = "legacy-image";
function b(e, r) {
  return {
    id: s,
    localizerId: s,
    t: [
      0,
      0,
      0
    ],
    q: [
      0,
      0,
      0,
      1
    ],
    rotationSource: "explicit",
    isPrimary: !0,
    enabled: !0,
    localizer: {
      id: s,
      kind: c,
      name: "",
      imageUrl: e,
      widthM: r,
      displayAssetId: null
    }
  };
}
function y(e, r) {
  return {
    t: [
      e.x,
      e.y,
      e.z
    ],
    q: [
      -r.z,
      r.w,
      r.x,
      -r.y
    ]
  };
}
export {
  y as a,
  d as i,
  m as n,
  f as r,
  b as t
};

//# sourceMappingURL=localizerTracking-DNXVMp7I.js.map